const RewindSelectorPlayIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0003 23.2727C20.0169 23.2727 23.273 20.0166 23.273 16C23.273 11.9834 20.0169 8.72729 16.0003 8.72729C11.9836 8.72729 8.72754 11.9834 8.72754 16C8.72754 20.0166 11.9836 23.2727 16.0003 23.2727Z"
      fill="#E5FD49"
      strokeWidth={0}
    />
    <path
      d="M14.5459 13.7704C14.5459 13.48 14.8696 13.3067 15.1112 13.4678L18.4557 15.6975C18.6716 15.8414 18.6716 16.1587 18.4557 16.3026L15.1112 18.5322C14.8696 18.6933 14.5459 18.5201 14.5459 18.2297V13.7704Z"
      fill="#000000"
      strokeWidth={0}
    />
  </svg>
);

export default RewindSelectorPlayIcon;
